package views.componentes

import androidx.compose.runtime.*
import ffEspHorizontalMM
import ffValidar
import fontSmall
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.attributes.AutoComplete.Companion.off
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.*

import utils.*
//import utils.ff.Companion.giClick
import utils.ff.Companion.giId
import utils.ff.Companion.gsBrowser

//import utils.ff.Companion.gsKey
import utils.ff.Companion.println0

//private var textH: HTMLInputElement? = null


class input46(

    var text: String
)

private fun geraId(_tela: String, _id: String, _tipo: String): String {
    var id = _id
    if (id.equals("")) {
        giId += 1;
        id = _tela + "_$_tipo${giId.ffZeroLeft(6)}"
    }
    return id
}

@Composable
fun ffInput44(
    //aparentemente funciona em coletores mais antigo
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true,
    _onFocusIn: (Boolean) -> Unit,
    _onFocusOut: (Boolean) -> Unit,
    //_onKeyUpEnter: (Boolean) -> Unit,
    //_onclick: (Boolean) -> Boolean
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    if (_valor.tipo().equals(""))
        _valor.tipo(_tipoCampo)


    //_valor.carregado("nao")
    //Div({ classes("input-group-append") }) {

    return Div({ id("div${_valor.id()}")
        style { width(width.percent); fontSize(fontSmall); } }) {
        if (!_text.equals("") && !_text.ffCopy(1, 1).equals(":")) {
            //println0("vai99 por nome no span = span${_valor.id()}, text = ${_valor.text()}")
            Span({ id("${_valor.tela()} span${_valor.id()}") }) {
                if (_valor.span().equals(""))
                    Text("$_text".trim())
                else
                    Text(_valor.span().trim())
            }

            Br()
        }
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {


            Input(

                type = if (_tipoCampo.ffSubstring1(1).equals("D") && _valor.enabled() && _valor.text().length < 14) {
                    InputType.Number
                } else if (_tipoCampo.equals("NS") && _valor.enabled()) {
                    if (_valor.text().ffSoNumero().equals(_valor.text()))
                        InputType.Number
                    else
                        InputType.Text
                } else if (_tipoCampo.ffSubstring1(1).equals("N")) {
                    InputType.Number
                } else if (_tipoCampo.equals("PS") && _valor.enabled()) {
                    InputType.Password
                } else {
                    InputType.Text
                },

                attrs = {
                    autoComplete(off)
                    //_valor.inputType(_tipoCampo)

                    //step(1)
                    if (!_valor.id().equals("")) {
                        id(_valor.id())
                    }

                    println0("atribui88 defaultValue _valor = ${_text} carregado = ${_valor.carregado()}")

                    if (!_text.equals("") && (_valor.carregado().equals("") || _valor.carregado().ffCopy(1).equals("n"))) {
                        println0("atribui88 defaultValue = $_text")
//                        defaultValue(_text)
                        placeholder(_text)
                    }

                    classes("form-control")
                    if (_tipoCampo.equals("NS") || _tipoCampo.equals("S")) {
                        if (_valor.text().equals(""))
                            placeholder(_text)
                        else if (!_valor.enabled())
                            placeholder(_valor.text())
                    }

                    if (_tipoCampo.equals("N"))
                        style { (textAlign("right")); fontSize(fontSmall) }
                    else
                        style { fontSize(fontSmall) }


                    onFocusIn { _ ->
                        //println0("onFocusIn 45 ${_valor.text()}")
//                        if (_valor.text().equals(""))
//                            _valor.getHTMLInputElement()!!.value = ""
//                        else {
                            if (!_valor.text().equals("")) {
                                _valor.getHTMLInputElement()!!.value = _valor.text()
                            }
                            //value(_valor.text())
                            //_valor.carregado("sim")
                            //_valor.text_set()

//                        }
                        _onFocusIn.invoke(true)
                    }

                    onFocusOut {
                        //println0("zuza96 vai aqui ${_valor.text()}")
                        //_valor.getHTMLInputElement()!!.selectionEnd = _valor.text().length + 1
//                        println0("onFocusOut 45")
                        _onFocusOut.invoke(true)

//                        if (gsBrowser.contains("mobile")) {
//                            gsKey = "Enter"
//                            _valor.key("Enter")
//                        }
                    }

                    onInput {

                        //println0("onInput 45")
                        //it.value = 0
                        //_valor.textSimples(it.value.toString())
                    }

                    onChange {
                        //println0("zuza96 vai aqui ${_valor.text()}")
                        //_valor.getHTMLInputElement()!!.selectionEnd = _valor.text().length + 1
                        //println0("onChange 45")

                        val ed = _valor.getHTMLInputElement()
                        if (ed != null)
                            _valor.textSimples(ed.value.toString())

                        //_valor.text(_valor.text_getPROBLEMA())

                        if (_tipoCampo.equals("NS") || _tipoCampo.equals("S")) {
                            _valor.text(
                                ffValidar(
                                    _valor.text(),
                                    _valor.tipo(),
                                    _max
                                )
                            )
                        } //else {
                        //value(_valor.text())
                        //}
                        //println0("zuza98 vai aqui ${_valor.text()}")
                        //println0("zuza97 vai aqui ${_valor.text()} ${_valor.value}")
                        if (_tipoCampo.equals("NS") || _tipoCampo.equals("S")) {
                            //println0("vai setar o value 44")
                            _valor.setVal(_valor.text())
                            //_valor.setVal(_valor.text())
                        } else {
                            if (_tipoCampo.ffCopy(1).equals("N") &&
                                _valor.text().ffSoNumero().equals(_valor.text())
                            ) {
                                value(_valor.text())
                            }
                        }

//                        _valor.setFocus("");
//                        if (gsBrowser.contains("mobile")) {
//                            ffMsgWindow("tecla do mobile key=${_valor.key()} gsKey=$gsKey")
//                        }
                        //ffMsgWindow("tecla do mobile key=${_valor.key()} gsKey=$gsKey")

                        if (_valor.key().equals("Enter") ||
                            (gsBrowser.contains("mobile") && !_valor.text().equals(""))
                        ) {
                            //ffMsgWindow("vai setar Enter")
                            _valor.key("Enter");
                            gsKey = "Enter" //necessário para o celular
                        }

                    }

                    onFocus {
                        //msgAviso("")
                        //_valor.text("")
                        _valor.key("")
                        _valor.setFocus("entrou")
                    }

//                    onFocusOut { não liberar isso
//
//                        if (_valor.key().equals("Enter") || (gsBrowser.contains("mobile") && !_valor.text().equals(""))) {
//                            _valor.key("Enter"); gsKey = "Enter"; //necessário para o celular
//                        }
//                    }

                    onKeyDown {
                        //27891962051349
                        //println0("onKeyDown " + it.getNormalizedKey() + " text=" + _valor.text() + " id=" + _valor.id() + " key=" + _valor.key())
                        //_valor.text(_valor.text_get())

                        //_valor.setVal(_valor.text())
                        //value(_valor.text())

                        //_valor.text_set()
                        //value()
                        //msgAviso(it.getNormalizedKey() + _valor.id())
                        //msgAviso(it.getNormalizedKey() + " " + _valor.id() + " " + _valor.atualizar())
                        //if (Mobile)
                        //msgAviso("tecla ${it.getNormalizedKey()} pressionada")

                        if (it.getNormalizedKey().equals("Enter")
                            || it.getNormalizedKey().equals("Backspace")
                            || it.getNormalizedKey().equals("Delete")
                        ) {

                            gsKey = it.getNormalizedKey();
                            _valor.key(it.getNormalizedKey());

                            /*
                            val ed = _valor.getHTMLInputElement()
                            if (ed != null) {
                                _valor.text(ed.value.toString())
                            }
                            */

                            if ("Backspace,Delete".contains(it.getNormalizedKey()) && _valor.text().length == 1) {
                                _valor.text("")
                            }


                            //println0("onKeyDown"); //; println0(it.getNormalizedKey() + " " + _valor.text())
                        } else if (!_valor.key().equals("")) {
                            _valor.key("")
                            gsKey = ""
                        }


//                        if (gsBrowser.contains("mobile")) {
//                            ffMsgWindow("tecla do mobile key=${_valor.key()} gsKey=$gsKey")
//                        }

                    }


//                    onKeyUp { //
//                        println0("onKeyUp")
//                        _valor.onKeyPressENTER(_onKeyUpEnter)
                    /*
                    if (("Enter".contains(it.getNormalizedKey()))
                        || (_valor.key().equals("Enter") && gsKey.equals("Enter"))) {
                        gsKey = "false"
                        _valor.key("v")
                        _onKeyUpEnter.invoke(true)
//                            _acao.invoke(true)
                    }


                     */

//                        if ("Enter".contains(it.getNormalizedKey()))
//                            _onKeyUpEnter.invoke(true)
//                    }


/*
                    if ((!_valor.text().equals("") && _valor.carregado().equals("nao")) || !_valor.enabled()) {
                        println0("aqui valor carregado 0")
                        _valor.text_set()
                        if (!_valor.carregado().equals("nao") && _valor.enabled()) {
                            //println0("_valor.enabled=" + _valor.enabled() + " carregado=" + _valor.carregado())
                            _valor.carregado("sim")
                        }
                    }

 */

                    //não vai ter o resultado esperado se a tela já não estiver montada
                    if (_valor.carregado().equals("nao") && !_valor.text().equals("")) {
                        //println0("99vai colocar o valor, carregado = ${_valor.carregado()} e valor = ${_valor.text()}")
                        //if (_valor.carregado().equals("nao") && !_valor.text().equals(""))
                        _valor.text_set()
                        _valor.carregado("sim")
                        //value(_valor.text())
                        //_valor.text()
                    }

                    //_valor.text_set()

                    if (!_valor.enabled())
                        disabled()

                    if (_valor.setFocus().equals("true")) {

                        try {
                            if (!_valor.id().equals("")) {
                                _valor.setFocus("");
                                (document.getElementById(_valor.id()) as HTMLInputElement).focus()
                            }
                        } catch (e: Exception) {
                            println0("Falha ao fazer setFocus ${_valor.id()} erro = ${e.message}")
                        }

                        println0(
                            "zuza779_1 tipoCampo = " + _valor.tipo()
                                .ffSubstring1(1) + " enabled = " + _valor.enabled() + " focus " + _valor.setFocus()
                        )
                    }
                }

            )
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}


